
import React, { useEffect, useContext, useRef, useState } from 'react'

import myAdminImg from "../../assets/myadmin.png"
import dashboradimageImg from "../../assets/alert.png"
import orderviewImg from "../../assets/order.png"
import positionImg from "../../assets/dashboard.png"


import '../styleCss/a.css'

import { Link, useNavigate } from 'react-router-dom';
import { LiaHandPointRightSolid } from 'react-icons/lia'
import { FaHandPointRight } from 'react-icons/fa'
import { BiSolidHandRight } from 'react-icons/bi'
import TypingText from './TypingText'
import SEO from '../SEO'
import Footer from './Footer'

const MainPage = () => {


  const [showContactInfo, setShowContactInfo] = useState();


  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const media = window.matchMedia("(width <= 1024px)");

    function updateNavbar(e) {
      const isMobile = e.matches;
      const menu_div = document.getElementById("mob_menu");
      if (isMobile) {
        menu_div.style.display = "block";
        navbar.setAttribute("inert", "");
      } else {
        menu_div.style.display = "none";
        navbar.removeAttribute("inert");
      }
    }

    media.addEventListener("change", updateNavbar);
    updateNavbar(media);

    return () => media.removeEventListener("change", updateNavbar);
  }, []);




  const openSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");




    navbar.classList.add("show");
    openButton.setAttribute("aria-expanded", "true");
    openButton.style.display = "none";
    navbar.removeAttribute("inert");
  };

  const closeSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");

    if (openButton.getAttribute('aria-expanded') === 'true') {


      navbar.classList.remove('show');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.setAttribute('style', 'display: block;');
      navbar.setAttribute('inert', '');

    }
  };







  // useEffect(() => {




  //   const texts = [
  //     "Hi :)",
  //     "Trade With Algo Controller :)",
  //     "Amazing Breakeven & Trailing Feature :)",
  //     "Unlimited Trade :)",
  //     "Boost Your Trading With One-Click Precision :)",
  //     "Login Now and Enjoy Free Features :)",
  //     "AlgoController.com :)"
  //   ];
  //   let isCancelled = false;



  //   async function typeText(text, elementIds) {
  //     for (let i = 0; i < text.length; i++) {
  //       if (isCancelled) return; 
  //       for (let id of elementIds) {
  //         const el = document.getElementById(id);
  //         if (el) el.textContent += text.charAt(i);
  //       }
  //       await new Promise(res => setTimeout(res, 50));
  //     }
  //   }

  //   async function typeWriter() {
  //     for (let j = 0; j < texts.length; j++) {
  //       if (isCancelled) return;
  //       for (let id of ["ft", "ftt"]) {
  //         const el = document.getElementById(id);
  //         if (el) el.textContent = ""; 
  //       }

  //       await typeText(texts[j], ["ft", "ftt"]);

  //       if (j < texts.length - 1) {
  //         await new Promise(res => setTimeout(res, 2500));
  //       }
  //     }
  //   }

  //   typeWriter();


  //   return () => {
  //     isCancelled = true;
  //     ["ft", "ftt"].forEach(id => {
  //       const el = document.getElementById(id);
  //       if (el) el.textContent = "";
  //     });
  //   };

  // }, [])



  const data = [
    {
      img: positionImg,
      boxheader: "Position Details",
      boxinfo: [
        "1. Close your positions whenever you want, hassle-free.",
        "2. Instantly view your profit & loss in real-time.",
        "3. No hidden data, everything at your fingertips.",
        "4. Stay updated with every market move.",
        "5. 100% Fast and Secure Execution.",
      ]
    },


    {
      img: orderviewImg,
      boxheader: "Order Details",
      boxinfo: [
        "1. Keep track of every webhook order in one place.",
        "2. Instantly view when and how trades are executed.",
        "3. Clear visibility into every orders, no surprises.",
        "4. Exit or cancel orders with a single click.",
        "5. Accuracy Across Accounts."
      ]
    },
    {
      img: dashboradimageImg,
      boxheader: "Alert Dashboard",
      boxinfo: [
        "1. Manage all your alerts in one place.",
        "2. Organize alerts by symbol, time, or status.",
        "3. View past alerts for better analysis.",
        "4. Real-time updates of events on alert.",
        "5. 100% Fast and Secure Execution."
      ]
    },

    {
      img: myAdminImg,
      boxheader: "Trade Copier ",
      boxinfo: [
        "1. Easy to send request to admin.",
        "2. One click permission accept and remove feature.",
        "3. Pause/Unpause client at anytime.",
        "4. View all clients and their status in one place.",
        "5. Manage multiple clients effortlessly."
      ]
    },



  ];

  const [index, setIndex] = useState(0);


  // useEffect(() => {
  //   data.forEach((item) => {
  //     const img = new Image();
  //     img.src = item.img; 
  //   });
  // }, []);

  useEffect(() => {
    let interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % data.length);
    }, 4000);

    let timeout;

    const handleScroll = () => {
      clearInterval(interval);
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        interval = setInterval(() => {
          setIndex((prev) => (prev + 1) % data.length);
        }, 3000);
      }, 2000);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);




  const nextSlide = () => setIndex((prev) => (prev + 1) % data.length);
  const prevSlide = () => setIndex((prev) => (prev - 1 + data.length) % data.length);


  const [activeTab, setActiveTab] = useState("free");

  const tabs = [
    { id: "free", label: "FREE", },
    { id: "silver", label: "SILVER", },
    { id: "gold", label: "GOLD", },
    { id: "diamond", label: "DIAMOND", },

  ];

  // const handleProcessOverview = () => {
  //   navigate('/process-overview')


  // }

  const handleGetStarted = () => {
    window.open("https://sandbox.algocontroller.com/signup")
  }

  // const [activeTab, setActiveTab] = useState("free");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId); // ✅ switch tab first

    // ✅ scroll to the section smoothly
    setTimeout(() => {
      const section = document.getElementById(tabId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // small delay so React renders the section
  };






  return (

    <div>

      <SEO
        title="Algo Controller Trading | Algo Controller"
        description="Get real-time stock trading signals, live market updates, and PnL insights to make smarter trading decisions."
        url="https://www.algocontroller.com/"
        image="https://www.algocontroller.com/og-home.png"
      
      />

      <div id="mob_menu">
        <div className="row">
          <div className="col-10" style={{ padding: "1.5rem 2rm" }}>
            <a id="ftt"></a>
          </div>
          <div className="col-2">
            <button id="open-sidebar-button" style={{ marginLeft: "-20px" }} onClick={openSidebar} aria-label="open sidebar" aria-expanded="false" aria-controls="navbar">
              <svg xmlns="http://www.w3.org/2000/svg" height="5vh" viewBox="0 -960 960 960" width="5vh" fill="#050505"><path d="M165.13-254.62q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.86q7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.87q-7.22 7.12-17.9 7.12H165.13Zm0-200.25q-10.68 0-17.9-7.27-7.23-7.26-7.23-17.99 0-10.74 7.23-17.87 7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.27 7.23 7.26 7.23 17.99 0 10.74-7.23 17.87-7.22 7.13-17.9 7.13H165.13Zm0-200.26q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.87q7.22-7.12 17.9-7.12h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.86q-7.22 7.13-17.9 7.13H165.13Z" /></svg>
            </button>
          </div>
        </div>

      </div>



      <nav id="navbar">
        <ul>
          <li>
            <br /><br /><br />
            <TypingText className=''></TypingText>
            <button id="close-sidebar-button" onClick={closeSidebar} aria-label="close sidebar">
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="4" y1="4" x2="20" y2="20" stroke="black" strokeWidth="2" strokeLinecap="round" />
                <line x1="20" y1="4" x2="4" y2="20" stroke="black" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          </li>
          <li className="home-li"><a className="active-link" aria-current="page" id="ft"></a></li>
          <li onClick={closeSidebar} ><a href="/#price" className="menu">Cost &amp; Plans</a></li>




          <li >
            <Link to="/process-overview" onClick={() => window.scrollTo(0, 0)}> Process Overview</Link>

            {/* <a href="#" class="menu">Process Overview</a> */}
          </li>

          <li >
            <Link to="/education" onClick={() => window.scrollTo(0, 0)}> Education</Link>
          </li>
          <li >
            <Link to="/doc" onClick={() => window.scrollTo(0, 0)}> Doc</Link>
          </li>

          <li onClick={closeSidebar}><a href="/#mission" className="menu">Our Mission</a></li>

          <li onClick={closeSidebar} ><a href="https://sandbox.algocontroller.com" className="menu accent-link">Login / Signup</a></li>

        </ul>
      </nav>
      
      {/* <h1 className = 'text-center bg-black text-white items-center p-2'>Trade Smarter, Not Harder – Easy Trade with Algo Controller</h1> */}

      <div className='cardwrapper'>

     
        <div id="overlay" onClick={closeSidebar} aria-hidden="true"></div>

        <div className="head">
          <section className="slider">
            <div className="list">  
               {/* <h1 className='text-black text-center top-0'>Algo Trading Signals to Maximize Your Stock Market Profits</h1> */}
              <div className="item active">





                <div className='content-child'>
                 
                  <div className='content-wrapper'>
                     

                    <div className='image-box items-center '>
                      {/* <img src={data[index].img}
                        loading="lazy"></img> */}

                      {/* <div class="image-box"> */}
                      <div class="slide "><img src={positionImg} alt=" Algo Controller Postion Tab" /></div>
                      <div class="slide"><img src={orderviewImg} alt=" Algo Controller OrderView Tab" /></div>
                      <div class="slide"><img src={dashboradimageImg} alt=" Algo Controller Home Tab" /></div>
                      <div class="slide"><img src={myAdminImg} alt=" Algo Controller Admin Dashboard" /></div>



                      {/* </div> */}



                    </div>




                    <div className='text-box'>

                      <div className="boxinfo">
                        <h1 className="boxheader">{data[index].boxheader}</h1>
                        {data[index].boxinfo.map((line, i) => (
                          <p key={i}>{line}</p>
                        ))}

                        <div className='w-[100%] flex items-center justify-center mt-15 rounded-lg  '>
                          <button
                            onClick={
                              handleGetStarted
                            }
                            className="
    px-6 py-3 text-sm        
    mt-5

    sm:px-8 sm:py-3 sm:text-base
    md:px-12 md:py-3 md:text-lg
    lg:px-16 lg:py-4 lg:text-xl
   border border-white/60
    rounded-lg shadow-2xl 
    bg-gradient-to-r from-black/20 to-white shadow-black
    transform transition duration-300 
    hover:-translate-y-2 hover:shadow-2xl 
  "
                          >
                            Get Started
                          </button>

                        </div>

                      </div>

                      {/* <div className="boxinfo">
                  

                        <div className="slider text-slider">
                          {data.map((item, index) => (
                            
                            <div className="slide" key={index}>

                            

                              <h4 className="boxheader text-black">{item.boxheader}</h4>

                              {item.boxinfo.map((line, i) => (
                                <p key={i}>{line}</p>
                              ))}
                             
                            </div>
                          ))}
                        </div>

                      </div> */}

                      {/* <div className="w-full flex items-center justify-center ">
                        <button
                          onClick={handleGetStarted}
                          className="px-6 py-2 sm:px-8 sm:py-3 md:px-12 md:py-3 lg:px-16 lg:py-4 text-sm sm:text-base md:text-lg lg:text-xl rounded-lg shadow-2xl bg-gradient-to-r from-rose-300 to-red-400 shadow-black transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
                        >
                          Get Started
                        </button>
                      </div> */}

                      <div className="flex justify-around mt-8 items-center w-full">
                        <button
                          onClick={prevSlide}

                          className="
      flex px-4 sm:px-6 md:px-8 lg:px-10   /* padding grows with screen */
      py-2 text-sm sm:text-base md:text-lg /* text scales */
      hover:bg-gray-300 rounded-lg shadow-2xl bg-transparent border border-gray-400
      transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl shadow-black text-white
    "
                        >
                          Prev
                        </button>

                        <button
                          onClick={nextSlide}

                          className="
      px-4 sm:px-6 md:px-8 lg:px-10
      py-2 text-sm sm:text-base md:text-lg
      hover:bg-blue-400 rounded-lg shadow-2xl bg-transparent border border-gray-400
      transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl shadow-black
      text-white
    "
                        >
                          Next
                        </button>
                      </div>



                    </div>





                  </div>



                </div>

              </div>


            </div>
          </section>

        </div>




        <span className="card"></span>
        <section className="head2" id="comingsoon">
          <div className="containerf scroll-right"> </div>
          <marquee className="marquee" behavior="" direction="right">🚀Successful investing is about managing risk, not avoiding it. Patience is one of the most important factors!</marquee>
        </section>

        <span className="card"></span>
        <div className="war"> Get started risk-free today with our fully featured demo account—live broker support with Zerodha, Dhan, Groww and more is coming very soon! Stay tuned for launch.</div>

      </div >
      <br />
      {/* <!-- PRice --> */}
      <section className="price" id="price">
        <div className="container">
          <div className="panel pricing-table">

            <div className="pricing-plan">

              <h2
                className={`pricing-header cursor-pointer ${activeTab === "free" ? "text-blue-500" : ""
                  }`}
                onClick={() => handleTabClick("free")}
              >
                Free
              </h2>
              <ul className="pricing-features">
                <li className="pricing-features-item">NSE / BSE</li>
                <li className="pricing-features-item">Unlimited Strategies</li>
                <li className="pricing-features-item">Unlimited Trade</li>
                <li className="pricing-features-item">Ultra-fast alert execution — under 100-500ms.</li>
                <li className="pricing-features-item">Single Take Profit / Stop Loss.</li>
                <li className="pricing-features-item">Alerts are accepted with a minimum gap of 10 minutes.</li>
                <li className="pricing-features-item">Trade Copier feature is not available.</li>
                <li className="pricing-features-item">Copier Client Management Dashboard is not available.</li>
                <li className="pricing-features-item">Maximum Position → 5</li>

                <li className="pricing-features-item">24/7 Customer Support</li>

              </ul>
              <span className="pricing-price">&#x20b9; 0.0</span>

              <div className="icon-wrapper" id="upgrade">

                <a
                  href="#/"
                  className={`pricing-button cursor-pointer ${activeTab === "free" ? "text-blue-500  underline" : "text-gray-700"
                    }`}
                  onClick={() => handleTabClick("free")}
                >
                  Get Now
                </a>


              </div>
            </div>

            <div className="pricing-plan">


              <h2
                className={`pricing-header cursor-pointer ${activeTab === "silver" ? "text-blue-500" : ""
                  }`}
                onClick={() => handleTabClick("silver")}
              >
                Silver
              </h2>
              <ul className="pricing-features">
                <li className="pricing-features-item">NSE / BSE</li>
                <li className="pricing-features-item">Unlimited Strategies</li>
                <li className="pricing-features-item">Unlimited Trade</li>
                <li className="pricing-features-item">Ultra-fast alert execution — under 100-500ms.</li>
                <li className="pricing-features-item">+ Breakeven / Trailing Stop.</li>
                <li className="pricing-features-item">Alerts are accepted with a minimum gap of 10 seconds.</li>
                <li className="pricing-features-item">Trade Copier accessed only by an invitation link.</li>
                <li className="pricing-features-item">Trade Copier feature is available with a limit of up to 5 clients. </li>
                <li className="pricing-features-item">Copier Client Management Dashboard is available.</li>
                <li className="pricing-features-item">Maximum Position → 10</li>

                <li className="pricing-features-item">24/7 Customer Support</li>
              </ul>
              <span className="pricing-price">&#x20b9; 199/-</span>
              <div className="icon-wrapper" id="upgrade">
                {/* <a href="#/" className="pricing-button">Get Now</a> */}
                <a
                  href="#/"
                  className={`pricing-button cursor-pointer ${activeTab === "silver" ? "text-blue-500  underline" : "text-gray-700"
                    }`}
                  onClick={() => handleTabClick("silver")}
                >
                  Get Now
                </a>


              </div>
            </div>

            <div className="pricing-plan">


              <h2
                className={`pricing-header cursor-pointer ${activeTab === "gold" ? "text-blue-500" : ""
                  }`}
                onClick={() => handleTabClick("gold")}
              >
                Gold
              </h2>
              <ul className="pricing-features">
                <li className="pricing-features-item">NSE / BSE</li>
                <li className="pricing-features-item">Unlimited Strategies</li>
                <li className="pricing-features-item">Unlimited Trade</li>
                <li className="pricing-features-item">Ultra-fast alert execution — under 100-500ms.</li>
                <li className="pricing-features-item">+ Breakeven / Trailing Stop.</li>
                <li className="pricing-features-item">Alerts are accepted without any time gap.</li>
                <li className="pricing-features-item">Trade Copier accessed only by an invitation link.</li>
                <li className="pricing-features-item">Trade Copier feature is available with a limit of up to 10 clients.</li>
                <li className="pricing-features-item">Copier Client Management Dashboard is available.</li>
                <li className="pricing-features-item">Maximum Position → 15</li>

                <li className="pricing-features-item">24/7 Customer Support</li>
              </ul>
              <span className="pricing-price">&#x20b9; 499/-</span>
              <div className="icon-wrapper" id="upgrade">
                {/* <a href="#/" className="pricing-button  is-featured">Get Now</a> */}
                <a
                  href="#/"
                  className={`pricing-button is-featured cursor-pointer ${activeTab === "gold" ? "text-blue-500" : ""
                    }`}
                  onClick={() => handleTabClick("gold")}
                >
                  UPGRADE
                </a>


              </div>
            </div>

            <div className="pricing-plan">
              {/* <h2 className="pricing-header">Diamond</h2> */}

              <h2
                className={`pricing-header cursor-pointer ${activeTab === "diamond" ? "text-blue-500" : ""
                  }`}
                onClick={() => handleTabClick("diamond")}
              >
                Diamond
              </h2>
              <ul className="pricing-features">
                <li className="pricing-features-item">NSE / BSE</li>
                <li className="pricing-features-item">Unlimited Strategies</li>
                <li className="pricing-features-item">Unlimited Trade</li>
                <li className="pricing-features-item">Ultra-fast alert execution — under 100-500ms.</li>
                <li className="pricing-features-item">+ Breakeven / Trailing Stop.</li>

                <li className="pricing-features-item">Alerts are accepted without any time gap.</li>
                 <li className="pricing-features-item">Trade Copier accessed only by an invitation link.</li>
                <li className="pricing-features-item">Trade Copier feature is available with no limits.</li>
                <li className="pricing-features-item">Copier Client Management Dashboard is available.</li>
                <li className="pricing-features-item">Maximum Position → 20</li>

                <li className="pricing-features-item">24/7 Customer Support</li>
              </ul>


              <span className="pricing-price"  >&#x20b9; 999/-</span>







              <div className="icon-wrapper" id="upgrade">





                <a
                  href="#/"
                  className={`pricing-button cursor-pointer ${activeTab === "diamond" ? "text-blue-500  underline" : "text-gray-700"
                    }`}
                  onClick={() => handleTabClick("diamond")}
                >
                  Get Now
                </a>





              </div>



            </div>

          </div>
        </div>
      </section >
      <br></br>


      <div className="mx-10  flex flex-col justify-center items-center rounded-t-2xl mt-10 ">

        <div
          className="flex w-full max-w-8xl bg-transparent p-3 sm:p-4 md:p-6 gap-2 sm:gap-4 md:gap-6 lg:gap-10 
  rounded-t-2xl overflow-hidden backdrop-blur-3xl shadow-[0_0_10px_rgba(0,0,0,0.2)]"
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-1 items-center justify-center gap-1 sm:gap-2 
      rounded-t-lg py-3 sm:py-3 md:py-4 px-2 sm:px-3 md:px-4
      text-[10px] sm:text-xs md:text-sm lg:text-lg font-medium transition-colors 
      shadow-[0_0_10px_rgba(0,0,0,0.2)]
      ${activeTab === tab.id
                  ? "bg-white/10 border-b-2 border-black/80 text-black"
                  : "bg-black text-white hover:bg-gray-200"
                }`}
            >
              {tab.icon}
              {tab.label}
              {/* <span className="hidden xs:inline">{tab.label}</span> */}
            </button>
          ))}
        </div>



        <div className=" 
       
      
       border backdrop-blur-md bg-whit/20 shadow-xl rounded-b-2xl 
                border-[rgba(255,255,255,0.2)] 
   
       w-full max-w-[100%] p-4  ">
          <div id="free">
            {activeTab === "free" && (




              <div >

                <div className="terms space-y-6">
                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">1. Demo Accounts Only (for now):</h4>
                    <p className="text-black">
                      At present, we only provide demo accounts. Our team is actively working to
                      integrate with leading brokers like <b>Zerodha</b>, <b>Dhan</b>, <b>Groww</b>, and more to bring
                      live trading very soon.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">2. Free Account Features:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Users can send alerts via webhook through TradingView or their own tools.</li>
                      <li>After an alert is triggered, the user must wait <b>10 minutes</b> before the next alert can be accepted.</li>
                      <li>All open orders and positions will be automatically closed <b>2 minutes</b> prior to market closing.</li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">3. Free Account Validity:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>The expiry of a free account is automatically extended <b>2 days</b> before the expiry date.</li>
                      <li><b>Please note:</b> Free services can be discontinued by the admin at any time without prior notice.</li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">4. Regulatory Compliance:</h4>
                    <p className="text-black">
                      We strictly follow <b>SEBI</b> guidelines. In case of any legal or compliance issues,
                      the admin reserves the right to disconnect services without prior notice.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">5. Market Data Disclaimer:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>
                        For live market data, we rely on trusted third-party brokers. The data is super fast,
                        but since it depends on the broker, we cannot provide a <b>100% uptime guarantee</b>.
                      </li>
                      <li>If the broker disconnects the data feed, our services may also be temporarily paused.</li>
                    </ul>
                  </div>

                  <hr />


                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Maximum Position Limit:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>The system supports up to <b>5 active positions at the same time</b>.</li>
                      <li>Ensures risk is managed and the portfolio doesn’t get overexposed. <b></b> </li>
                    </ul>
                  </div>

                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">7. Our Promise:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Ultra-fast order execution — under <b>100-500ms</b>.</li>
                      <li><b>24/7 customer support</b> to assist you anytime.</li>
                    </ul>


                  </div>

                </div>



                <div className='flex justify-end gap-4'>

                  <LiaHandPointRightSolid className='mt-10 h-10 w-10 text-blue-400 hover:text-blue-700' />


                  <button onClick={() => window.open("https://sandbox.algocontroller.com")} className="mt-8 
                    px-8 mr-10 font-samibold shadow-lg bg-[#48aaff] hover:bg-blue-500 text-white 
                     py-3 rounded-xl border  transition">
                    SING UP
                  </button>
                </div>

              </div>
            )}
          </div>


          <div id="silver">
            {activeTab === "silver" && (
              <div >




                <div className="terms space-y-6">
                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">1. Demo Accounts Only (for now):</h4>
                    <p className="text-black">
                      At present, we only provide demo accounts. Our team is actively working to
                      integrate with leading brokers like <b>Zerodha</b>, <b>Dhan</b>, <b>Groww</b>, and more to bring
                      live trading very soon.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">2. Silver Account Features:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Users can send alerts via webhook through TradingView or their own tools.</li>
                      <li>
                        After an alert is triggered, the user must wait <b>10 seconds</b> before the next alert can be accepted.
                      </li>
                      <li>
                        <b>TradeCopier</b> feature is available with a limit of up to <b>5 clients</b>.
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">3. Silver Account Validity:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>
                        If payment is not received by the due date, the account type will be downgraded
                        from <b>Silver</b> to <b>Free</b>, and all free account rules will apply.
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">4. Regulatory Compliance:</h4>
                    <p className="text-black">
                      We strictly follow <b>SEBI</b> guidelines. In case of any legal or compliance issues,
                      the admin reserves the right to disconnect services without prior notice.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">5. Market Data Disclaimer:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>
                        For live market data, we rely on trusted third-party brokers. The data is super fast,
                        but since it depends on the broker, we cannot provide a <b>100% uptime guarantee</b>.
                      </li>
                      <li>
                        If the broker disconnects the data feed, our services may also be temporarily paused.
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Maximum Position Limit:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>The system supports up to <b>10 active positions at the same time</b>.</li>
                      <li>Ensures risk is managed and the portfolio doesn’t get overexposed. <b></b> </li>
                    </ul>
                  </div>

                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Our Promise:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Ultra-fast order execution — under <b>100-500ms</b>.</li>
                      <li><b>24/7 customer support</b> to assist you anytime.</li>
                    </ul>
                  </div>
                </div>


                <div className='flex justify-end gap-4'>
                  <LiaHandPointRightSolid className='mt-10 h-10 w-10 text-blue-400 hover:text-blue-700' />

                  <button onClick={() => window.open("https://sandbox.algocontroller.com/dashboard/payment")} className="mt-8 
                    px-8 mr-10 font-samibold shadow-lg bg-[#48aaff] hover:bg-blue-500 text-white 
                     py-3 rounded-xl border  transition">
                    BUY NOW
                  </button>
                </div>


              </div>


            )}
          </div>

          <div id="gold">

            {activeTab === "gold" && (
              <div>

                <div className="terms space-y-6">
                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black" >1. Demo Accounts Only (for now):</h4>
                    <p className="text-black">
                      At present, we only provide demo accounts. Our team is actively working to
                      integrate with leading brokers like <b>Zerodha</b>, <b>Dhan</b>, <b>Groww</b>, and more to bring
                      live trading very soon.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">2. Gold Account Features:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Users can send alerts via webhook through TradingView or their own tools.</li>
                      <li><b>Unlimited alerts</b> accepted without any time gap.</li>
                      <li>
                        <b>TradeCopier</b> feature is available with a limit of up to <b>10 clients</b>.
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">3. Gold Account Validity:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>
                        If payment is not received by the due date, the account type will be downgraded
                        from <b>Gold</b> to <b>Free</b>, and all free account rules will apply.
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">4. Regulatory Compliance:</h4>
                    <p className="text-black">
                      We strictly follow <b>SEBI</b> guidelines. In case of any legal or compliance issues,
                      the admin reserves the right to disconnect services without prior notice.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">5. Market Data Disclaimer:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>
                        For live market data, we rely on trusted third-party brokers. The data is super fast,
                        but since it depends on the broker, we cannot provide a <b>100% uptime guarantee</b>.
                      </li>
                      <li>
                        If the broker disconnects the data feed, our services may also be temporarily paused.
                      </li>
                    </ul>
                  </div>
                  <hr />


                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Maximum Position Limit:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>The system supports up to <b>15 active positions at the same time</b>.</li>
                      <li>Ensures risk is managed and the portfolio doesn’t get overexposed. <b></b> </li>
                    </ul>
                  </div>

                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Our Promise:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Ultra-fast order execution — under <b>100-500ms</b>.</li>
                      <li><b>24/7 customer support</b> to assist you anytime.</li>
                    </ul>
                  </div>
                </div>


                <div className='   flex justify-end gap-4 '>

                  <LiaHandPointRightSolid className='mt-10 h-10 w-10 text-blue-400 hover:text-blue-700' />


                  <button onClick={() => window.open("https://sandbox.algocontroller.com/dashboard/payment")} className="mt-8 
                    px-8 mr-10 font-samibold shadow-lg bg-[#48aaff] hover:bg-blue-500 text-white 
                     py-3 rounded-xl border  transition">
                    BUY NOW
                  </button>


                </div>

              </div>
            )}

          </div>

          <div id="diamond">
            {activeTab === "diamond" && (
              <div>



                <div className="terms space-y-6">
                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">1. Demo Accounts Only (for now):</h4>
                    <p className="text-black">
                      At present, we only provide demo accounts. Our team is actively working to
                      integrate with leading brokers like <b>Zerodha</b>, <b>Dhan</b>, <b>Groww</b>, and more to bring
                      live trading very soon.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">2. Diamond Account Features:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Users can send alerts via webhook through TradingView or their own tools.</li>
                      <li><b>Unlimited alerts</b> accepted without any time gap.</li>
                      <li>
                        <b>TradeCopier</b> feature is available without any limit.
                        <em> (Try not to go over 20, as it may cause slight execution delays.)</em>
                      </li>
                      <li>
                        For <b>VIP clients</b> we offer a private dedicated server:
                        <ul className="list-disc list-inside ml-6 space-y-1">
                          <li>Credentials are required to access market data.</li>
                          <li>The minimum add-on amount is ₹20,000.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">3. Diamond Account Validity:</h4>
                    <p className="text-black">
                      If payment is not received by the due date, the account type will be downgraded
                      from <b>Diamond</b> to <b>Free</b>, and all free account rules will apply.
                    </p>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">4. Regulatory Compliance:</h4>
                    <p className="text-black">
                      We strictly follow <b>SEBI</b> guidelines. In case of any legal or compliance issues,
                      the admin reserves the right to disconnect services without prior notice.
                    </p>
                  </div>
                  <hr />


                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Maximum Position Limit:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>The system supports up to <b>20 active positions at the same time</b>.</li>
                      <li>Ensures risk is managed and the portfolio doesn’t get overexposed. <b></b> </li>
                    </ul>
                  </div>

                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">5. Market Data Disclaimer:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>
                        For live market data, we rely on trusted third-party brokers. The data is super fast,
                        but since it depends on the broker, we cannot provide a <b>100% uptime guarantee</b>.
                      </li>
                      <li>
                        If the broker disconnects the data feed, our services may also be temporarily paused.
                      </li>
                    </ul>
                  </div>
                  <hr />

                  <div>
                    <h4 className="text-lg font-bold mb-2 text-black">6. Our Promise:</h4>
                    <ul className="list-disc list-inside space-y-2 text-black">
                      <li>Ultra-fast order execution — under <b>100-500ms</b>.</li>
                      <li><b>24/7 customer support</b> to assist you anytime.</li>
                    </ul>
                  </div>
                </div>


                <div className='flex justify-end gap-4 '>
                  <LiaHandPointRightSolid className='mt-10 h-10 w-10 text-blue-400 hover:text-blue-700' />


                  <button onClick={() => window.open("https://sandbox.algocontroller.com/dashboard/payment")} className="mt-8 
                    px-8 mr-10 font-samibold shadow-lg bg-[#48aaff] hover:bg-blue-500 text-white 
                     py-3 rounded-xl border  transition">
                    BUY NOW
                  </button>

                </div>

              </div>
            )}
          </div>
        </div>
      </div>

      <section id="mission">
        <div className="responsive-container-block bigContainer">
          <div className="responsive-container-block Container bottomContainer">
            <div className="ultimateImg">
              <img className="mainImg" src="/assets/candel.jpg" alt="AlgoController - Trade Smarter, Not Harder" />
              <div className="purpleBox">
                <p className="purpleText">
                  The market doesn’t forgive emotions — but it rewards discipline. Stay calm, stay consistent, and let the edge be yours.
                </p>
                <img className="stars" src="/assets/startsvg.svg" />
              </div>
            </div>
            <div className="allText bottomText">
              {/* <!-- <p class="text-blk headingText">
        Our Mission
      </p> --> */}
              <p className="text-blk subHeadingText">
                Our Mission: Trade Smarter, Not Harder
              </p>
              <p className="text-blk description">
                At AlgoController, our mission is simple yet powerful —<br />
                <b>to empower every trader to navigate the stock market with confidence, clarity, and control.</b>
                <br /><br />
                We believe that trading shouldn't be a source of stress or guesswork.<br />
                That’s why we’ve built intelligent tools that reduce emotional decision-making and maximize every possible opportunity.
                <br /><br />
                <b>We aim to ensure that:</b>
                <br />
                &nbsp;&nbsp;1. No trader is left behind.
                <br />
                &nbsp;&nbsp;2. Every trade is backed by logic, not luck.
                <br />
                &nbsp;&nbsp;3. Stress is replaced with smart strategies.
                <br />
                &nbsp;&nbsp;4. Losses are minimized through automation, breakeven safety, and intelligent exits.
                <br />
                &nbsp;&nbsp;5. Whether you're trading on NSE or BSE, our goal is to help you trade peacefully, consistently, and profitably — using every advantage technology can offer.
                <br /><br />
                <b>Let AlgoController handle the complexity,
                  so you can focus on your vision, not the volatility.</b>
              </p>

            </div>
          </div>
        </div>


      </section>

      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" >&times;</span>
          <h2>Hello!</h2>
          <p><b>We’re working hard behind the scenes to bring something great!</b><br />
            Some features and links will be available soon.<br />
            Thank you for your patience — our website is currently under construction.</p>
        </div>
      </div>


      <br /><br />
      {/* <span className="card"></span>
      <section id="footer">
        <div id="footer1">



          <Link to="/terms-condition" style={{ textDecoration: "none", color: "black" }}> Terms & Conditions</Link>
          <span> | </span>
          <Link to="/privacy-policy" style={{ textDecoration: "none", color: "black" }}> Privacy Policy</Link>
          <span> | </span>

          <Link to="/refund-policy" style={{ textDecoration: "none", color: "black" }}> Refund Policy</Link>
          <span className=''> | </span>
          <Link to="/sponsership-disclaimer" style={{ textDecoration: "none", color: "black" }}>Sponsership Disclaimer</Link>
          <span> | </span>
          <Link to="/referral" style={{ textDecoration: "none", color: "black" }}>  Referral Terms & Conditions </Link>






          <div className="icon-wrapper" id="upgrade">




            <button onClick={() => setShowContactInfo(true)}
          
            >
              Contact Us
            </button>

            {showContactInfo && (
              <div className="fixed inset-0 bottom-52 flex items-center justify-center bg-black/40 z-[9999]">
                <div className=" bg-[#F7A38E] rounded-xl shadow-lg p-2 w-[350px]">
             
                  <div className="flex items-center justify-between mb-2">
                    <h2 className="text-lg font-semibold text-center flex-1">
                      Contact Details
                    </h2>
                    <button
                      className="text-gray-500 hover:text-red-500 text-xl font-bold "
                      onClick={() => setShowContactInfo(false)} 
                    >
                      ×
                    </button>
                  </div> */}

      {/* Body */}
      {/* <div className="w-full flex flex-col items-center justify-center gap-1">
                    <div className="bg-red-200 rounded-md px-4 h-12 flex items-center justify-center w-full max-w-xs">
                      <p className="text-gray-700 text-center">support@algocontroller.com</p>
                    </div>

                    <div className="bg-red-200 rounded-md px-4 h-12 flex items-center justify-center w-full max-w-xs">
                      <p className="text-gray-700 text-center">+91 8684953093</p>
                    </div>
                  </div>

                </div>
              </div>



            )

            }


          </div>
        </div> */}


      {/* 
        <div id="footer2">AlgoController automates trade execution by linking your broker and exchange accounts. While powerful, automated trading involves risk. Use with care and ensure you understand the potential impact.

          By using AlgoController, you accept full responsibility for all trading activity and agree to proceed at your own risk.

          We are not liable for any losses, technical issues, or third-party errors. You are responsible for monitoring your trades and
          ensuring proper signal execution.
          <br /><br />
          &#xA9; 2025 AlgoController, All rights reserved. <br />
          Registered MSME (Udyam): UDYAM-HR-15-0030895 ||
          Verified under Ministry of MSME, Govt. of India
        </div>
      </section>

      <a href="https://wa.me/918684953093?text=Hi" target="_blank" className="chaty-tooltip pos-left" data-form="chaty-form-0-Whatsapp" data-hover="Whatsapp">
        <img src="/assets/chaticon.svg" width="40" height="40" id="uparrow"
          style={{
            cursor: "pointer", bottom:
              "0px", right: "20px",
            msTransformOrigin: "100% 100%",
            WebkitTransformOrigin: "100% 100%",
            transformOrigin: "100% 100%",
            zIndex: "9999997",
            position: "fixed"
          }} />
      </a> */}

      <Footer></Footer>

    </div >
  )
}

export default MainPage